export default function PedidoTotalBar({
  total,
  onPreview,
  disabled = false,
}) {
  return (
    <>
      {/* Spacer para que el contenido no quede tapado en móvil */}
      <div className="h-20 md:hidden" />

      {/* Barra inferior */}
      <div
        className="
          fixed bottom-0 left-0 right-0 z-40
          md:static
          bg-white dark:bg-slate-900
          border-t border-slate-200 dark:border-slate-700
          md:border-none
        "
      >
        <div
          className="
            max-w-5xl mx-auto
            px-4 py-3
            flex items-center justify-between gap-3
          "
        >
          {/* Total */}
          <div className="flex flex-col leading-tight">
            <span className="text-[11px] text-slate-500 dark:text-slate-400">
              Total
            </span>
            <span className="text-lg font-bold text-emerald-500">
              ${Number(total || 0).toFixed(2)}
            </span>
          </div>

          {/* Acción */}
          <button
            type="button"
            disabled={disabled}
            onClick={onPreview}
            className={`
              flex-1 max-w-xs
              px-4 py-3 rounded-xl
              text-sm font-semibold
              transition
              ${
                disabled
                  ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                  : "bg-emerald-500 hover:bg-emerald-600 text-white"
              }
            `}
          >
            Vista previa
          </button>
        </div>
      </div>
    </>
  );
}
